export const custom_table_sorts = {
    methods: {
        vehicles_list_sort: function(items, index, isDesc) {
            let all_datetime_fields_names = ['access_start_datetime', 'access_expiration_datetime', 'detection_datetime']
            items.sort((a, b) => {
              if (all_datetime_fields_names.includes(index[0])) {
                    let a_date = new Date(a[index]['$date'])
                    let b_date = new Date(b[index]['$date'])
                if (!isDesc[0]) {
                    return a_date - b_date
                } else {
                    return b_date - a_date
                }
              }
              else {
                if(typeof a[index] !== 'undefined'){
                  if (!isDesc[0]) {
                     return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
                  }
                  else {
                      return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
                  }
                }
              }
            });
        return items;
        }
    }
}